// Package Imports
import { queryOptions } from '@tanstack/react-query'

// Module Imports
import { ONLINE_PLAYERS_REFETCH_MS } from '@/modules/dashboard/dashboard.constants'
import {
  getDashboardOverview,
  getDashboardStats,
  getOnlinePlayers,
} from '@/modules/dashboard/dashboard.service'
import type {
  TDashboardOverview,
  TDashboardStats,
  TOnlinePlayers,
} from '@/modules/dashboard/dashboard.types'

export const dashboardStatsQueryOptions = () =>
  queryOptions<TDashboardStats>({
    queryKey: ['dashboardStats'],
    queryFn: getDashboardStats,
  })

export const dashboardOverviewQueryOptions = () =>
  queryOptions<TDashboardOverview>({
    queryKey: ['dashboardOverview'],
    queryFn: getDashboardOverview,
    staleTime: 30_000,
  })

export const onlinePlayersQueryOptions = () =>
  queryOptions<TOnlinePlayers>({
    queryKey: ['onlinePlayers'],
    queryFn: getOnlinePlayers,
    refetchInterval: ONLINE_PLAYERS_REFETCH_MS,
    refetchIntervalInBackground: false,
    staleTime: 0,
  })
